module.exports = __webpack_public_path__ + "static/media/Gateway.f9449396.svg";